import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { UtilitiesService } from 'src/app/core/utilities.service';

@Component({
  selector: 'app-e-ticketing-info',
  templateUrl: './e-ticketing-info.component.html',
  styleUrls: ['./e-ticketing-info.component.scss']
})
export class ETicketingInfoComponent implements OnInit {



        bearer;
        feedbackForm = [];
        topicId;
        id:any;
        sub;

        constructor(
          private svc: StoreService,
          private router: Router,
          private route: ActivatedRoute,
          public utils: UtilitiesService,
        ) { }

        ngOnInit(): void {
          this.sub = this.route.params.subscribe(params => {
               this.id = params['id'];
               console.log("pass id",this.id);

          });
          this.bearer = localStorage.getItem('bearer');
          this.getFeedbackForm();
        }

        getFeedbackForm() {
            this.svc.getFeedbackInfo(this.bearer, this.id,  ).subscribe(res => {
              this.feedbackForm = res['data'];
              console.log(this.feedbackForm);
            })
          }

          goFeedbackFormPage(id){
           //this.router.navigate(['/property-detail',id]);
           let navigationExtras: NavigationExtras = {
             state: {
               topicId: this.topicId
             }
           };
           this.router.navigate(['/dashboard/feedback-form',id], navigationExtras);
         }
  }
